import { Button, Grid, TextField } from '@material-ui/core';
import { useState } from 'react';

const Pressure = () => {

    const [input, setInput] = useState({
        lowerLimit: 0,
        lowerDelay: 0,
        lowerBypassLimit: 0,
        upperLimit: 0,
        upperDelay: 0,
        upperBypassLimit: 0 
    })
    
    const [errors, setErrors] = useState({
        lowerLimit: "",
        lowerDelay: "",
        lowerBypassLimit: "",
        upperLimit: "",
        upperDelay: "",
        upperBypassLimit: "",
    })


    function onChangeLimit(field, e) {
        console.log("onChangeLimit", field, e.target.value)
        if (field == "lowerLimit" && (e.target.value > 10 || e.target.value < 0 || e.target.value === "")) {
            setErrors(prev =>({
                ...prev,
                "lowerLimit": "Min 0, Max 10"
            }))
        } else if (field == "lowerLimit") {
            setErrors(prev =>({
                ...prev,
                "lowerLimit": ""
            }))
        }

        if (field == "lowerDelay" && (e.target.value > 100 || e.target.value < 0 || e.target.value === "")) {
            setErrors(prev =>({
                ...prev,
                "lowerDelay": "Min 0, Max 100"
            }))
        } else if (field == "lowerDelay") {
            setErrors(prev =>({
                ...prev,
                "lowerDelay": ""
            }))
        }

        if (field == "lowerBypassLimit" && (e.target.value > 10 || e.target.value < 0 || e.target.value === "")) {
            setErrors(prev =>({
                ...prev,
                "lowerBypassLimit": "Min 0, Max 10"
            }))
        } else if (field == "lowerBypassLimit") {
            setErrors(prev =>({
                ...prev,
                "lowerBypassLimit": ""
            }))
        }

        if (field == "upperLimit" && (e.target.value > 10 || e.target.value < 0 || e.target.value === "")) {
            setErrors(prev =>({
                ...prev,
                "upperLimit": "Min 0, Max 10"
            }))
        } else if (field == "upperLimit") {
            setErrors(prev =>({
                ...prev,
                "upperLimit": ""
            }))
        }
        if (field == "upperDelay" && (e.target.value > 100 || e.target.value < 0 || e.target.value === "")) {
            setErrors(prev =>({
                ...prev,
                "upperDelay": "Min 0, Max 100"
            }))
        } else if (field == "upperDelay") {
            setErrors(prev =>({
                ...prev,
                "upperDelay": ""
            }))
        }
        if (field == "upperBypassLimit" && (e.target.value > 10 || e.target.value < 0 || e.target.value === "")) {
            setErrors(prev =>({
                ...prev,
                "upperBypassLimit": "Min 0, Max 10"
            }))
        } else if (field == "upperBypassLimit") {
            setErrors(prev =>({
                ...prev,
                "upperBypassLimit": ""
            }))
        }

        setInput(prev => (
            {
                ...prev,
                [field]: e.target.value
            }
        ))
    }

    function onSet() {
        console.log("onSet", input)
        if (
            (input.upperBypassLimit !== 0 || input.lowerBypassLimit !== 0) &&
            (Number(input.upperBypassLimit) < Number(input.upperLimit) ||
            Number(input.upperLimit) < Number(input.lowerLimit) || 
            Number(input.lowerLimit) < Number(input.lowerBypassLimit))
        ) {
            console.log("error")
        }
    }

    return (
        <div style={{ padding: "2rem" }}>
            <div className="row" style={{ justifyContent: "space-evenly" }}>
                <div className="col-12 col-sm-5" style={{ border: "1px solid black", borderRadius: "10px", padding: "1rem 3rem", marginBottom: "20px" }}>
                    <div className="row" style={{ marginBottom: '20px', marginTop: '20px' }}>
                        <TextField value={input.lowerLimit} type="number" error={errors.lowerLimit == '' ? false : true} helperText={errors.lowerLimit} style={{ width: '70%' }} label="Lower Limit (BAR)" onChange={(e)=>{onChangeLimit("lowerLimit", e)}}/>
                        <Button variant="contained" color="primary" style={{ width: '30%', height: "90%", alignSelf: "flex-end" }} onClick={onSet}>SET</Button>
                    </div>

                    <div className="row" style={{ marginBottom: '20px', marginTop: '20px' }}>
                        <TextField value={input.lowerDelay} type="number" style={{ width: '70%' }} error={errors.lowerDelay == '' ? false : true} helperText={errors.lowerDelay} label="Trigger Delay (SEC)" onChange={(e)=>{onChangeLimit("lowerDelay", e)}}/>
                        <Button variant="contained" color="primary" style={{ width: '30%', height: "90%", alignSelf: "flex-end" }} onClick={onSet}>SET</Button>
                    </div>

                    <div className="row" style={{ marginBottom: '20px', marginTop: '20px' }}>
                        <TextField value={input.lowerBypassLimit} type="number" style={{ width: '70%' }} error={errors.lowerBypassLimit == '' ? false : true} helperText={errors.lowerBypassLimit} label="Lower Bypass Limit (BAR)" onChange={(e)=>{onChangeLimit("lowerBypassLimit", e)}}/>
                        <Button variant="contained" color="primary" style={{ width: '30%', height: "90%", alignSelf: "flex-end" }} onClick={onSet}>SET</Button>
                    </div>
                </div>

                <div className="col-12 col-sm-5" style={{ border: "1px solid black", borderRadius: "10px", padding: "1rem 3rem", marginBottom: "20px" }}>
                    <div className="row" style={{ marginBottom: '20px', marginTop: '20px' }}>
                        <TextField value={input.upperLimit} type="number" style={{ width: '70%' }} error={errors.upperLimit == '' ? false : true} helperText={errors.upperLimit} label="Upper Limit (BAR)" onChange={(e)=>{onChangeLimit("upperLimit", e)}}/>
                        <Button variant="contained" color="primary" style={{ width: '30%', height: "90%", alignSelf: "flex-end" }} onClick={onSet}>SET</Button>
                    </div>

                    <div className="row" style={{ marginBottom: '20px', marginTop: '20px' }}>
                        <TextField value={input.upperDelay} type="number" style={{ width: '70%' }}  error={errors.upperDelay == '' ? false : true} helperText={errors.upperDelay} label="Trigger Delay (SEC)" onChange={(e)=>{onChangeLimit("upperDelay", e)}}/>
                        <Button variant="contained" color="primary" style={{ width: '30%', height: "90%", alignSelf: "flex-end" }} onClick={onSet}>SET</Button>
                    </div>

                    <div className="row" style={{ marginBottom: '20px', marginTop: '20px' }}>
                        <TextField value={input.upperBypassLimit} type="number" style={{ width: '70%' }}  error={errors.upperBypassLimit == '' ? false : true} helperText={errors.upperBypassLimit} label="Upper Bypass Limit (BAR)" onChange={(e)=>{onChangeLimit("upperBypassLimit", e)}}/>
                        <Button variant="contained" color="primary" style={{ width: '30%', height: "90%", alignSelf: "flex-end" }} onClick={onSet}>SET</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Pressure